<alaris-card>
	@if (tRows.length > 0 || tRows.length === 0 && state.isFiltersApplied) {
		<div class="table-management">
			<div class="left">
				<span class="total"> {{ totalTitle | translate }}: {{ total }} </span>
				<button (click)="editTableFilter()" alaris-button bType="outline" size="lg">
					<alaris-icon name="icon-filter-vertical"></alaris-icon>
					{{ enableButtons.filters.title | translate }}
					@if (state.isFiltersApplied) {
						<div class="indicator"></div>
					}
				</button>
			</div>
			<div class="right">
				<button (click)="refresh()" alaris-button bType="outline" size="lg">
					<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
					{{ 'actions.refresh_page' | translate }}
				</button>
				<button (click)="export()" [disabled]="!!(exporting$ | async)" alaris-button bType="outline" size="lg"
					[disabled]="!this.user.allowed(['clients.edit'])">
					@if (exporting$ | async) {
						<alaris-spinner></alaris-spinner>
					} @else {
						<alaris-icon name="icon-export"></alaris-icon>
					}
					{{ 'gl.export' | translate }}
				</button>
				<button (click)="edit()" alaris-button bType="primary" size="lg" [disabled]="!this.user.allowed(['clients.edit'])">
					<alaris-icon class="in-primary" name="icon-plus"></alaris-icon>
					{{ 'clients.add' | translate }}
				</button>
			</div>
		</div>
	}
	<div [alarisLoading]="loading$" alarisHorizontalOverflow class="content">
		@if (tRows.length === 0 && !state.isFiltersApplied) {
			<app-empty-table type="clients" [disabled]="!this.user.allowed(['clients.edit'])" (newClient)="edit()"></app-empty-table>
		} @else {
			<alaris-table (filtersChange)="_applyFilter($event)"
						  (sortingChange)="_applySorting($event)"
						  [filters]="state.filters()"
						  [dblClickRowAction]="dblClickRowAction.bind(this)"
						  [dropDownRowActions]="dropDownRowActions"
						  [rowActions]="rowActions"
						  [tHeaders]="tHeaders()"
						  [tRows]="tRows"
						  [resizable]="resizable"
						  [templates]="{productIds, availableInterfaces}"
						  alarisOverflowFader>
			</alaris-table>
		}
	</div>
	<div class="footer">
		<alaris-pagination (page)="_pageChange($event)"
						   [activePage]="activePage"
						   [class.without-table-bar]="selection !== null && selection.length === 0"
						   [hidden]="total === 0"
						   [pageSizeOptions]="pageSizeOptions"
						   [pageSize]="pageSize"
						   [total]="total"
						   class="pagination">
		</alaris-pagination>
	</div>
</alaris-card>

<ng-template #productIds [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="tagFilter">
		@if (productsService.loading$ | async) {
			<alaris-spinner size="xs" style="transform: scale(0.5,0.5)"></alaris-spinner>
		} @else {
			@if (data.productId) {
				<alaris-tag mode="gray-light" [fill]="false" class="product" size="lg">
					@if (!eapiEnable) {
						<div class="text-ellipsis">{{ data.productId }}</div>
					} @else {
						<div class="text-ellipsis">{{ transform(data.productId)?.product_caption }} ({{ data.productId }})</div>
					}
				</alaris-tag>
			} @else {}
		}
	</div>
</ng-template>

<ng-template #availableInterfaces [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="availableInterfaces">
		@for (interface of data.availableInterfaces; track interface) {
			<alaris-tag>{{ interface }}</alaris-tag>
		}
	</div>
</ng-template>
